import React from 'react';

import Link from 'components/atoms/Link';
import Paragraph from 'components/atoms/Paragraph';
import PATHS from 'utils/paths';

interface NotFoundProps {
  buttonLabel?: string;
  description?: string;
}

const NotFound: React.FC<NotFoundProps> = ({ description, buttonLabel }) => (
  <div className="t-notFound">
    <div className="t-notFound_table">
      <div className="t-notFound_table-title u-mb-5">
        <h5>
          404
        </h5>
      </div>
      <div className="u-mb-33">
        <Paragraph.Text
          content={description}
          size={{ fontSize: '16', lineHeight: '19' }}
          modifiers={['700', 'white']}
        />
      </div>
      <Link type="button" className="t-notFound_table-button" href={PATHS.HOME}>
        <Paragraph.Text
          content={buttonLabel}
          size={{ fontSize: '16', lineHeight: '19' }}
          modifiers={['cyan', 'uppercase']}
        />
      </Link>
    </div>
  </div>
);

NotFound.defaultProps = {
  description: 'Xin lỗi! trang hiện không được tìm thấy',
  buttonLabel: 'trở lại'
};

export default NotFound;
